import BoltBanner from "../boltClone/BoltBanner";
import BoltOwnCode from "../boltClone/BoltOwnCode";
import { lazy, Suspense } from "react";

const LyftTeamlogo = lazy(() => import("../LyftClone/LyftTeamlogo"));
const BoltSuperlative = lazy(() => import("../boltClone/BoltSuperlative"));
const BoltNeed = lazy(() => import("../boltClone/BoltNeed"));
const BoltDrive = lazy(() => import("../boltClone/BoltDrive"));
const BoltJourney = lazy(() => import("../boltClone/BoltJourney"));
const BoltBuild = lazy(() => import("../boltClone/BoltBuild"));
const BoltForYou = lazy(() => import("../boltClone/BoltForYou"));
const BoltDevelopement = lazy(() => import("../boltClone/BoltDevelopement"));
const BoltCustom = lazy(() => import("../boltClone/BoltCustom"));
const BoltSmart = lazy(() => import("../boltClone/BoltSmart"));
const BoltWhiteLabel = lazy(() => import("../boltClone/BoltWhiteLabel"));
const BoltGen = lazy(() => import("../boltClone/BoltGen"));
const BoltGlobal = lazy(() => import("../boltClone/BoltGlobal"));
const ShuttleAppreciation = lazy(() => import("../../shuttle_software/ShuttleAppreciation"));
const TaxiFaq = lazy(() => import("../../taxiDispatchSoftware/TaxiFaq"));

const bannerData = {
  class: "bolt-banner",
  titlePart1: "Uride Clone App",
  titlePart2: "Development Company",
  description: "Leading experts in creating scalable, secure, and fully customizable taxi booking apps tailored for seamless user experiences.",
  image: "/assets/home/bolt-banner.webp",
  btn1: "contact us",
  btn2: "watch demo",
  counter1: {
    number: "2000+",
    text: "Apps Launched"
  },
  counter2: {
    number: "100+",
    text: "Expert Developers"
  },
  counter3: {
    number: "250+",
    text: "Happy Clients"
  },
  breadcrumbData: {
    newClass: "white-breadcrumb",
    list: [
      {
        page: "Home",
        slug: "/"
      },
      {
        page: "URide Clone App",
        slug: ""
      },
    ]
  }
};

const OwnCodeData = {
  box1: {
    image: "/assets/home/bolt-own-code-1.webp",
    title: "Own the Entire Source Code",
  },
  box2: {
    image: "/assets/home/bolt-own-code-2.webp",
    title: "Outstanding UI & Superior UX",
  },
  box3: {
    image: "/assets/home/bolt-own-code-3.webp",
    title: "Fully Customized Solution",
  },
  box4: {
    image: "/assets/home/bolt-own-code-4.webp",
    title: "Next-Level Features",
  },
}

const superlativeData = {
  titlePart1: "Why",
  titlePart2: "Uride Clone App",
  titlePart3: "Superlative For Taxi Booking Businesses?",
  description1: "In today’s rapidly evolving Canadian urban transit landscape, convenience and local trust are paramount to rider satisfaction. That’s where the Uride Clone app by Mobility Infotech becomes a transformative solution. Specifically tailored for Canada’s diversified cities and mid-sized towns, our advanced clone platform replicates Uride’s hyper-local approach while equipping you with a competitive edge. Whether you're a new entrepreneur planning to digitize local transport or a fleet owner scaling operations, our Uride Clone app offers a seamless blend of functionality and user-centric design. From real-time driver tracking to automated fare estimates and integrated payment options, every feature is built for smoother journeys across Canadian regions.",
  description2: "What elevates our solution isn’t just its tech capabilities—it’s the strategic business advantage it gives you. Enjoy features like city-specific branding, bilingual (English/French) support, surge pricing models, local promotions, and geo-zoning, helping you compete effectively across various provinces. Scalable by design, the Uride Clone app grows with your user base.In an increasingly competitive market, having the right platform is key. Choose Mobility Infotech’s Uride Clone app—the smarter, faster, and scalable solution to lead Canada’s taxi booking industry.",
}

const needData = {
  titlePart1: "Taxi",
  titlePart2: "App Development Solutions",
  titlePart3: "for Every Business Need",
  description: "Powering Canada’s transportation evolution—one ride at a time.",
  boxes: [
    {
      image: "/assets/home/bolt-need-1.webp",
      title: "On-Demand Taxi Booking Apps",
      para: "Launch real-time ride services with GPS-enabled ride-matching, secure payment support, and bilingual interfaces. Ideal for startups or fleet operators expanding in Canadian cities and rural regions.",
    },
    {
      image: "/assets/home/bolt-need-2.webp",
      title: "Ride-sharing or Carpooling Apps",
      para: "Promote cost-effective and eco-conscious transport with smart carpooling features. Match riders by route, split costs, and reduce emissions—ideal for cities like Toronto, Ottawa, and Montreal.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-3.webp",
      title: "Corporate Taxi Booking Apps",
      para: "Streamline business travel with admin-controlled taxi platforms. Ideal for Canadian enterprises managing employee logistics, including ride summaries and monthly invoicing.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-4.webp",
      title: "Rental or Hourly Taxi Booking Apps",
      para: "Allow customers to hire taxis on an hourly basis or for intercity travel—perfect for tourists, business professionals, or day-long errands across provinces.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-5.webp",
      title: "Luxury & Limousine Booking Apps",
      para: "Deliver exceptional service for premium clientele with luxury fleet options, chauffeur tracking, and custom itineraries. A great fit for events, hospitality, and VIP transport in Canada.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-6.webp",
      title: "Bike Taxi Booking Apps",
      para: "Enable fast and economical bike taxis for solo riders or small deliveries—particularly useful for busy city centers or university campuses across Canada.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-7.webp",
      title: "White-Label Taxi Booking Apps",
      para: "Quickly launch your own branded taxi service with a fully customized, white-label solution featuring your identity and market-specific features.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-8.webp",
      title: "Airport Transfer Taxi Apps",
      para: "Simplify airport rides with features like flight tracking, scheduled bookings, and driver alerts. A great solution for airports in Toronto, Vancouver, Calgary, and beyond.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-9.webp",
      title: "Electric Vehicle (EV) Taxi Apps",
      para: "Promote sustainable urban mobility by offering EV taxi options with charging station integration. Ideal for cities promoting green policies like Vancouver and Quebec.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-10.webp",
      title: "Paratransit or Accessible Taxi Apps",
      para: "Cater to passengers with mobility challenges by offering wheelchair-accessible vehicles, driver assistance tools, and compliance with Canadian accessibility regulations.",
      btn: "Request a free demo",
    },
  ],
}

const driveData = {
  titlePart1: "Drive Your Success with Canada’s ",
  titlePart2: "Leading Taxi App Development Experts",
  description: "Embrace innovation with our next-gen taxi app solutions and watch your business accelerate like never before.",
  image: "/assets/home/bolt-drive.webp",
  vector: "/assets/home/bolt-drive-vec.webp",
  boxes: [
    {
      image: "/assets/home/drive-circle-1.webp",
      title: "60% Rise in Ride Bookings Per Quarter",
    },
    {
      image: "/assets/home/drive-circle-2.webp",
      title: "45% Reduction in Average Pickup Times",
    },
    {
      image: "/assets/home/drive-circle-3.webp",
      title: "35% Lower Operational Costs Across the Board",
    },
    {
      image: "/assets/home/drive-circle-4.webp",
      title: "44% Boost in Overall Revenue Generation",
    },
    {
      image: "/assets/home/drive-circle-5.webp",
      title: "75% Increase in Customer Loyalty and Repeat Usage",
    },
    {
      image: "/assets/home/drive-circle-6.webp",
      title: "58% Growth in Positive Customer Feedback Each Quarter",
    },
  ],
}

const journeyData = {
  titlePart1: "Our Taxi App Development Journey That",
  titlePart2: "Drives Your Business Forward",
  description: "Planning to launch a Uride-like app? Understanding the operational flow is essential. Here's a streamlined look at how our Uride Clone App works to ensure seamless service and user satisfaction:",
  image: "/assets/home/bolt-journey.webp",
  vector: "/assets/home/bolt-journey-vec.webp",
}

const buildData = {
  titlePart1: "We Build Taxi Booking Apps",
  titlePart2: "Using Advanced Features",
  description: "At Mobility Infotech, we integrate the most advanced technologies into your Uride Clone taxi app to ensure an exceptional user experience, greater security, and efficient fleet operations. Here’s a look at the key innovations we bring:",
  btn: "more features",
  tabs: [{
    title: "AI-Powered Route Optimization",
    description: "Smart AI chooses optimal paths across Canadian cities and rural zones, ensuring quicker pickups, less fuel usage, and a better passenger experience.",
    icon: "/assets/home/bolt-build-icon-1.webp",
    image: "/assets/home/bolt-build-1.webp",
  },
  {
    title: "IoT for Vehicle Tracking",
    description: "Real-time IoT tracking improves safety, enables vehicle maintenance alerts, and enhances visibility for operators across regions.",
    icon: "/assets/home/bolt-build-icon-2.webp",
    image: "/assets/home/bolt-build-2.webp",
  },
  {
    title: "Chatbots for Customer Support",
    description: "Offer round-the-clock assistance in both English and French with intelligent chatbots handling queries, bookings, and feedback.",
    icon: "/assets/home/bolt-build-icon-3.webp",
    image: "/assets/home/bolt-build-3.webp",
  },
  {
    title: "Blockchain for Secure Payments",
    description: "Blockchain technology ensures tamper-proof, secure digital payments across Canadian bank integrations and digital wallets.",
    icon: "/assets/home/bolt-build-icon-4.webp",
    image: "/assets/home/bolt-build-4.webp",
  },
  {
    title: "Intelligent Driver Matching System",
    description: "Match riders with the most suitable drivers based on proximity, ratings, and historical data—reducing wait times and improving service levels.",
    icon: "/assets/home/bolt-build-icon-5.webp",
    image: "/assets/home/bolt-build-5.webp",
  },
  {
    title: "AR for Enhanced Navigation",
    description: "Drivers can rely on AR overlays for street identification, house numbers, and traffic signs—especially useful in densely populated or new neighbourhoods.",
    icon: "/assets/home/bolt-build-icon-6.webp",
    image: "/assets/home/bolt-build-6.webp",
  },],
}

const forYouData = {
  newClass: "bolt-for-you",
  text: "Mobility Infotech Will",
  text2: "Build a White-Label Taxi Booking",
  title: "App Just for You",
  btn: "BEGIN NOW!",
}

const developementData = {
  titlePart1: "Key Features of Our",
  titlePart2: "URide Clone Taxi App",
  titlePart3: "Development",
  description: "Partner with Mobility Infotech to create a robust, scalable, and future-ready Uride-like taxi app tailored for the Canadian market. From ride-hailing to real-time tracking and payments, our feature-rich app supports your growth and operational efficiency at every turn.",
  btn: "Get Started",
  customer: {
    image: "/assets/home/bolt-developement-1.webp",
    title: "Customer App",
    description: "Your customers enjoy a seamless experience with an intuitive interface and essential ride features, all backed by modern tech that enhances convenience and trust.",
    boxes: [
      {
        title: "Seamless Ride Booking",
        desc: "Easy-to-use interface for quick ride requests across Canadian regions."
      },
      {
        title: "Multiple Payment Options",
        desc: "Accept Interac, Apple Pay, Google Pay, credit cards, or cash."
      },
      {
        title: "Ride Sharing Availability",
        desc: "Share live trip details with family and friends for added safety."
      },
      {
        title: "Schedule a Ride",
        desc: "Plan airport pickups or business travel ahead of time."
      },
      {
        title: "Live Driver Tracking",
        desc: "View real-time driver location and ETA with GPS."
      },
      {
        title: "Push Notifications",
        desc: "Stay updated on ride status, promotions, and driver details."
      },
    ]
  },
  driver: {
    image: "/assets/home/bolt-developement-2.webp",
    title: "Driver App",
    description: "Our driver-focused Uride clone app empowers your drivers to manage their rides efficiently while ensuring a smooth and profitable journey.",
    boxes: [
      {
        title: "Direct Calling",
        desc: "Contact passengers from within the app for pickup details."
      },
      {
        title: "Optimized Route Navigation",
        desc: "Get live traffic-based suggestions with built-in mapping."
      },
      {
        title: "Start & End Ride Tracking",
        desc: "Toggle trip status with ease for clear billing and records."
      },
      {
        title: "Built-In Help & Support",
        desc: "Access app guides, route help, and payment details directly."
      },
      {
        title: "Earnings Dashboard",
        desc: "Daily earnings breakdown and payout tracking made simple."
      },
      {
        title: "In-App Chat",
        desc: " Secure, real-time messaging between drivers and riders."
      },
    ]
  },
  dispatcher: {
    image: "/assets/home/bolt-developement-3.webp",
    title: "Dispatcher Dashboard",
    description: "With our centralised and intelligent dispatcher console, you can monitor and manage every trip, vehicle, and driver in real time.",
    boxes: [
      {
        title: "Automatic Dispatching",
        desc: "Instantly assigns bookings to the nearest available driver."
      },
      {
        title: "Booking Management",
        desc: "Full control over ride dispatches, schedules, and approvals."
      },
      {
        title: "Live Fleet Tracking",
        desc: "Monitor vehicle movement city-wide through a live map."
      },
      {
        title: "Push Alerts for Dispatch",
        desc: "Send critical updates or route changes to drivers instantly."
      },
      {
        title: "Complete Transaction History",
        desc: "Track ride logs, cancellations, and fare breakdowns."
      },
      {
        title: "Smart Route Planning",
        desc: "Optimise driver routes to cut fuel costs and wait times."
      },
    ]
  },
  admin: {
    image: "/assets/home/bolt-developement-4.webp",
    title: "Admin Panel",
    description: "Gain complete control of your Uride clone taxi app with a powerful admin panel to oversee operations, analytics, and business performance.",
    boxes: [
      {
        title: "Driver Supervision",
        desc: "Easily assign drivers to locations or shifts as per demand."
      },
      {
        title: "In-Depth Analytics",
        desc: "Access reports on booking volume, income trends, and more."
      },
      {
        title: "Integrated Payment Management",
        desc: "Process and reconcile all payments securely."
      },
      {
        title: "Promo & Loyalty Management",
        desc: "Launch offers, promo codes, and loyalty programs easily."
      },
      {
        title: "Real-Time Admin Chat",
        desc: "Resolve driver or dispatcher queries immediately."
      },
      {
        title: "Booking Oversight",
        desc: "Monitor, approve, or edit bookings on the go."
      },
    ]
  },
}

const customData = {
  titlePart1: "Serving Diverse Industries",
  titlePart2: "with Custom Taxi App Solutions",
  description: "Whether you're a taxi fleet owner, a travel operator, or a large corporation, we provide scalable, feature-rich taxi booking apps to enhance customer experiences and streamline operations.",
  slides: [
    {
      image: "/assets/home/bolt-custom-slide-1.webp",
      title: "Corporate Transportation Providers",
      desc: "Deliver hassle-free staff transportation using intelligent routing, trip transparency, and automated scheduling tailored to corporate needs.",
    },
    {
      image: "/assets/home/bolt-custom-slide-2.webp",
      title: "Taxi App for fleet Businesses",
      desc: "Boost your fleet performance with integrated ride dispatch, real-time location tracking, and detailed analytics — all in one system.",
    },
    {
      image: "/assets/home/bolt-custom-slide-3.webp",
      title: "Events Transportation Providers",
      desc: "From destination weddings to mega conferences, simplify event transport with automated ride assignments, live GPS tracking, and centralized control.",
    },
    {
      image: "/assets/home/bolt-custom-slide-4.webp",
      title: "School And College Operation",
      desc: "Revolutionize school commutes with dynamic routing, live trip updates, and attendance automation — all from a single dashboard.",
    },
    {
      image: "/assets/home/bolt-custom-slide-5.webp",
      title: "Tour & Travel Operation",
      desc: "Empower your travel business with streamlined operations — from itinerary sync to passenger updates, all backed by smart mobility tools.",
    },
  ]
}

const smartData = {
  titlePart1: "Where",
  titlePart2: "Smart Mobility Meets",
  titlePart3: "Profitable App Business Models",
  description: "A taxi app’s revenue goes beyond just completing rides. Here’s how our Uride Clone App solutions by Mobility Infotech can deliver a high ROI for your business in Canada:",
  boxes: [
    {
      image: "/assets/home/bolt-smart-1.webp",
      title: "Trip Commissions",
      desc: "Charge a fee on every completed ride through the app.",
    },
    {
      image: "/assets/home/bolt-smart-2.webp",
      title: "Surge Pricing",
      desc: "Apply higher fares during rush hours or bad weather.",
    },
    {
      image: "/assets/home/bolt-smart-3.webp",
      title: "Reports and Analytics",
      desc: "Charge for premium vehicle categories like SUVs or EVs.",
    },
    {
      image: "/assets/home/bolt-smart-4.webp",
      title: "Cancellation Fees",
      desc: "Reduce losses from last-minute customer cancellations.",
    },
    {
      image: "/assets/home/bolt-smart-5.webp",
      title: "Leasing to Drivers",
      desc: " Monetize your fleet by leasing it to drivers directly.",
    },
    {
      image: "/assets/home/bolt-smart-6.webp",
      title: "Brand Advertising",
      desc: "Sell ad slots in the app to local businesses or service providers.",
    },
  ]
}

const WhiteLabelData = {
  title: "Develop Your White-Label Taxi Dispatch App with Mobility Infotech",
  description: "With over a decade of experience and the latest technology, Mobility Infotech helps you launch a fully customised Uride Clone App tailored for the Canadian market.",
  boxes: [
    {
      image: "/assets/home/bolt-white-1.webp",
      title: "White-Label Solution",
      desc: "Launch under your brand with complete feature control.",
    },
    {
      image: "/assets/home/bolt-white-2.webp",
      title: "Ready To Use",
      desc: "Deploy your app in under 3 days with our fast-track model.",
    },
    {
      image: "/assets/home/bolt-white-3.webp",
      title: "Highly Scalable",
      desc: "Expand to new Canadian cities or provinces effortlessly.",
    },
    {
      image: "/assets/home/bolt-white-4.webp",
      title: "Seamless Integration",
      desc: "Connect with Interac, local CRM, ERP, or third-party tools.",
    },
    {
      image: "/assets/home/bolt-white-5.webp",
      title: "Fully Customizable",
      desc: "Adapt features and design to match your business vision.",
    },
    {
      image: "/assets/home/bolt-white-6.webp",
      title: "User-Friendly Interface",
      desc: "Designed for maximum ease of use in English and French.",
    },
  ]
}

const genData = {
  titlePart1: "Next-Gen",
  titlePart2: "Taxi App Development",
  titlePart3: "Company Driving Innovation",
  description: "Partner with Mobility Infotech to build your ideal Uride Clone App and reach your business goals with these features:",
  boxes: [
    {
      image: "/assets/home/lyft-minimum-1.webp",
      title: "Automate dispatch from the admin panel.",
    },
    {
      image: "/assets/home/lyft-minimum-2.webp",
      title: "Track drivers in real time with GPS.",
    },
    {
      image: "/assets/home/lyft-minimum-3.webp",
      title: "Monitor operations anytime with live dashboards.",
    },
    {
      image: "/assets/home/lyft-minimum-4.webp",
      title: "Access detailed reports and analytics to optimize service.",
    },
    {
      image: "/assets/home/lyft-minimum-5.webp",
      title: "Offer multiple secure payment options.",
    },
    {
      image: "/assets/home/lyft-minimum-6.webp",
      title: "Enable customers to rate trips and provide instant feedback.",
    },
  ],
}

const globalData = {
  titlePart1: "Impact That",
  titlePart2: "Our Taxi App Development ",
  titlePart3: "Company Has Created Globally!",
  counter1: {
    number: "70",
    text: "Increase in Potential ROI",
  },
  counter2: {
    number: "64",
    text: "Increase in Customer Satisfaction",
  },
  counter3: {
    number: "40",
    text: "Increase in Bookings",
  },
  counter4: {
    number: "20",
    text: "Reduction in Maintenance Cost",
  },
}

const faqData = [
  {
    id: "0",
    question: "01. What is Mobility Infotech’s Uride Clone App?",
    answer: "Mobility Infotech’s Uride Clone App is a fully customizable taxi booking app replicating Uride’s model, built for Canadian transit needs.",
  },
  {
    id: "1",
    question: "02. Why should I choose Mobility Infotech for my taxi app development?",
    answer: "We bring over 10 years of experience, cutting-edge features, and Canada-specific insights to help your app thrive.",
  },
  {
    id: "2",
    question: "03. How customizable is the Uride Clone App developed by Mobility Infotech?",
    answer: "From logos and languages to ride types and payment gateways—every feature is fully customizable.",
  },
  {
    id: "3",
    question: "04. Does Mobility Infotech provide post-launch support and maintenance?",
    answer: "Yes. We offer 24/7 customer support, regular updates, and maintenance to ensure your operations stay flawless.",
  },
  {
    id: "4",
    question: "05. How quickly can Mobility Infotech deploy the Uride Clone App?",
    answer: "Our white-label taxi app can be live in as little as 3 days.",
  },
  {
    id: "5",
    question: "06. Can Mobility Infotech’s app integrate with existing business systems?",
    answer: "Absolutely. We support integration with CRMs, ERPs, and third-party Canadian payment providers like Interac.",
  },
  {
    id: "6",
    question: "07. What advanced technologies does Mobility Infotech use in its Uride Clone App?",
    answer: "Our tech stack includes AI, IoT, blockchain, AR, chatbots, and real-time analytics.",
  },
  {
    id: "7",
    question: "08. How does Mobility Infotech ensure the security of the app?",
    answer: "Through advanced encryption, secure gateways, and blockchain payment systems to prevent fraud and secure data.",
  },
];

export default function URideClone() {
  return (
    <>
      <BoltBanner data={bannerData} />
      <BoltOwnCode data={OwnCodeData} />
      
      <Suspense fallback={null}>
        <LyftTeamlogo heading={true} newClass="bolt-clone-team" />
        <BoltSuperlative data={superlativeData} />
        <BoltNeed data={needData} />
        <BoltDrive data={driveData} />
        <BoltJourney data={journeyData} />
        <BoltBuild data={buildData} />
        <BoltForYou data={forYouData} />
        <BoltDevelopement data={developementData} />
        <BoltCustom data={customData} />
        <BoltSmart data={smartData} />
        <BoltWhiteLabel data={WhiteLabelData} />
        <BoltGen data={genData} />
        <BoltGlobal data={globalData} />
        <ShuttleAppreciation />
        <div className="zip-faq-fixer">
          <TaxiFaq faqData={faqData} />
        </div>
      </Suspense>
    </>
  )
}
